exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.follow-team-content[data-v-6c794109] {\n    padding: 20px;\n}\n.follow-team-input[data-v-6c794109] {\n    height: 40px;\n}\n", ""]);

// exports
